<script>
    import Checkbox from './Checkbox.svelte';
    import { subjectCards } from './subjectCatalog.js';
    export let selectedSubject = '';

    let subjects = subjectCards();

    const selectSubject = (subjectName) => {
        // If the same subject is clicked, deselect it, otherwise select the new one
        selectedSubject = selectedSubject === subjectName ? '' : subjectName;
    };
</script>

<div class="checkbox-area">
    {#each subjects as subject}
        <Checkbox 
            icon={subject.icon}
            subject={subject.name} 
            isSelected={selectedSubject === subject.name} 
            onToggle={() => selectSubject(subject.name)} 
        />
    {/each}
</div>

<style>
    .checkbox-area {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        width: 100%;
    }
</style>
